"use strict"


// polyfills
import 'classlist-polyfill';
import 'window.requestanimationframe';
import objectFitImages from 'object-fit-images';


// global
import browser from './global/browser.js';
import animate from './global/animate.js';


// plugins
import lity from 'lity';


// modules
import mobileMenu from './modules/mobile-menu.js';
import desktopMenu from './modules/desktop-menu.js';
import hamburgerScroll from './modules/hamburger-scroll.js';
import videoBackground from './modules/videoBackground.js';
import parallax from './modules/parallax.js';


// objects
import expand from './modules/expand.js';


// init polyfills
objectFitImages();


// init
browser.addClasses();
mobileMenu.init();
desktopMenu.init();
hamburgerScroll.init();
expand.init();
videoBackground.init();
